import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import ClassCard from './ClassCard';

function CardComponent({ data }) {
  return (
    <>
      {data.map((elem) => (
        <Grid item xs={12} sm={6} md={4} key={data.indexOf(elem)} style={{ cursor: 'pointer' }}>
          <ClassCard classData={elem} />
        </Grid>
      ))}
    </>
  );
}

CardComponent.propTypes = {
  data: PropTypes.array
};

export default CardComponent;
